import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  button: {
    // minHeight: 0,
    flexGrow: 0,
  },
  buttonInner: {},
  buttonHover: {},
  buttonPressed: {},
  buttonFocus: {},
  buttonDisabled: {},
  buttonSmall: {},
  buttonMedium: {},
  buttonLarge: {},
  buttonIconRight: {},
  buttonIconLeft: {},
  buttonNoIcon: {},
  buttonOnlyCta: {},
  icon: {},
  iconHover: {},
  iconPressed: {},
  iconFocus: {},
  iconDisabled: {},
  iconSmall: {
    height: 14,
    width: 14,
  },
  iconMedium: {
    height: 18,
    width: 18,
  },
  iconLarge: {
    height: 20,
    width: 20,
  },
  iconIconRight: {},
  iconIconLeft: {},
  iconNoIcon: {},
  iconOnlyCta: {},
  text: {},
  textHover: {},
  textPressed: {},
  textFocus: {},
  textDisabled: {},
  textSmall: {
    fontSize: 14,
  },
  textMedium: {
    fontSize: 16,
  },
  textLarge: {
    fontSize: 18,
  },
  textIconRight: {},
  textIconLeft: {},
  textNoIcon: {
    borderBottomWidth: 1,
  },
  textOnlyCta: {},
});
